import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import { onHandNumberFormatWithoutDecimal } from '../../Services/formatting';
import { getISOWeek, isSameYear } from 'date-fns';

const IncomingStock = ({ stockArticle }) => {
  const { nextIncomingQuantity, nextIncomingDate, inventoryUnit, nextIncomeDateToolTip } = stockArticle;
  const [deliveryWeek, setDeliveryWeek] = useState(null);

  useEffect(() => {
    if (!nextIncomingDate) return;

    const incomingDate = new Date(nextIncomingDate);
    const currentDate = new Date();
    const currentWeek = getISOWeek(currentDate);

    let calculatedWeek = getISOWeek(incomingDate);

    if (
      isSameYear(incomingDate, currentDate) &&
      calculatedWeek < currentWeek
    ) {
      const estimatedWeeks = window.__litium.channelConfig.estimatedDeliveryWeek || 0;
      calculatedWeek = currentWeek + estimatedWeeks;
    }

    setDeliveryWeek(calculatedWeek);
  }, [nextIncomingDate]);

  return (
    <>
      {nextIncomingQuantity > 0 && (
        <div>
          <span>
            <svg className='stock-icon stock-icon--truck'>
              <use href='/ui/images/sprites/be-group.svg#delivery-truck'></use>
            </svg>
            <span>
              {onHandNumberFormatWithoutDecimal.format(nextIncomingQuantity)}{' '}
              {translate('orderrow.' + inventoryUnit)}
            </span>
          </span>
          <span>
           {new Date(nextIncomingDate).getFullYear()}{' '}
            {translate('incomingdate.weeknumber')} {deliveryWeek}
          </span>
          <span>
            <span
              className='data-tooltip'
              data-tip={nextIncomeDateToolTip}
              data-html='true'
            >
              <svg className='stock-icon stock-icon--attention'>
                <use href='/ui/images/sprites/be-group.svg#attention-i'></use>
              </svg>
            </span>
          </span>
        </div>
      )}
    </>
  );
};

export default IncomingStock;